import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation UpdateMaintenanceType($companyId: ID!, $id: ID!, $attributes: MaintenanceTypeAttributes!) {
    updateMaintenanceType(companyId: $companyId, id: $id, attributes: $attributes) {
      maintenanceType {
        id
        ...UpdatedMaintenanceType
      }
      errors {
        path
        message
      }
    }
  }

  fragment UpdatedMaintenanceType on MaintenanceType {
    id
    color
    name
  }
`
